export enum Subscription {
    ECMPremium = "ECMPremium",
    ECMStandard = "ECMStandard",
    ECMPro = "ECMPro",
    ECMEssentials = "ECMEssentials",
    AvaTaxExemptions = "AvaTaxExemptions",
    VEPRO = "VEMPro",
    VEPREMIUM = "VEMPremium",
    VEENT = "VEMEnt",
    AVATAXAP = "AvaTaxAP",
    ECMProComms = "ECMProComms",
    ECMPremiumComms = "ECMPremiumComms",
    AVAGLOBAL = "AvaGlobal",
    AVATAXST = "AvaTaxST",
    AVATAXPRO = "AvaTaxPro",
}

export const advanceSubscription = [
    Subscription.ECMPremium,
    Subscription.ECMStandard, // Standard is previous name of pro
    Subscription.ECMPro,
];

export const userRoleAdminSubscription = [
    Subscription.ECMPremium,
    Subscription.ECMEssentials, // Standard is previous name of pro
    Subscription.ECMPro,
    Subscription.ECMStandard,
    Subscription.VEPREMIUM,
    Subscription.VEPRO,
    Subscription.VEENT,
    Subscription.ECMProComms,
    Subscription.ECMPremiumComms,
];

export const vendorSubscription = [Subscription.VEPRO, Subscription.VEPREMIUM, Subscription.VEENT];

export const vendorExemptions = [Subscription.VEPRO, Subscription.VEPREMIUM];

export const vendorAvaTaxAPSubscription = [Subscription.AVATAXAP];

export const vendorPremiumOnlySubscription = [Subscription.VEPREMIUM, Subscription.VEENT];

export const ecmSubscription = [...advanceSubscription, Subscription.ECMEssentials];

export const lowerSubscription = [Subscription.AvaTaxExemptions, Subscription.ECMEssentials];

export const customerSubscription = [
    Subscription.ECMPremium,
    Subscription.ECMPro,
    Subscription.ECMEssentials,
    Subscription.AvaTaxExemptions,
];

export const avaTaxSubscription = [
    Subscription.AVAGLOBAL,
    Subscription.AVATAXST,
    Subscription.AVATAXPRO,
];

export enum EcmRole {
    CEMAdmin = "cem_admin",
    CEMManager = "cem_manager",
    CEMCertificateReviewer = "cem_certificatereviewer",
    CEMViewer = "cem_viewer",
    CEMNoAccess = "cem_noaccess",
    RETManager = "ret_manager",
    RETAssociate = "ret_associate",
    RETViewer = "ret_viewer",
    MSUser = "managed_service_user",
    CEMPreValidator = "cem_pre_validator",
}

export const certificateExemptionManagementTag = "cem_";

export const retailTag = "ret_";

export const ecmRETRole = Object.values(EcmRole).filter(x => x.startsWith(retailTag));

export enum AvataxRole {
    ECMRoleUser = "ECMRoleUser",
    ECMAccountUser = "ECMAccountUser",
    ECMCompanyUser = "ECMCompanyUser",
}

export enum AvaExemptTiers {
    AvaExemptTier1 = "AvaExemptTier1",
    AvaExemptTier2 = "AvaExemptTier2",
    AvaExemptTier3 = "AvaExemptTier3",
    AvaExemptTier4 = "AvaExemptTier4",
}

export const avataxTiers = [
    AvaExemptTiers.AvaExemptTier1,
    AvaExemptTiers.AvaExemptTier2,
    AvaExemptTiers.AvaExemptTier3,
    AvaExemptTiers.AvaExemptTier4,
];

export type AccessSubscription = (Subscription | AvaExemptTiers | "All")[];

export default Subscription;
